import React from "react";
import { Reveal, Eyebrow } from "./MarketingUI";
import { KeyRound, ScrollText, Link2, Database, Lock, Workflow } from "lucide-react";

const pillars = [
  { icon: KeyRound, title: "Role-Based Access", desc: "Viewer, analyst, manager and administrator roles enforced across the platform." },
  { icon: ScrollText, title: "Audit History", desc: "A durable record of who did what, and when." },
  { icon: Link2, title: "Official Source Traceability", desc: "Every record links back to its authoritative government source." },
  { icon: Database, title: "LIVE / SAMPLE Separation", desc: "Real legislative data is strictly isolated from demonstration data." },
  { icon: Lock, title: "Secure Authentication", desc: "Protected sign-in with session and CSRF safeguards." },
  { icon: Workflow, title: "Structured Government Workflows", desc: "Assignments, review states and reporting built for government process." },
];

export default function Trust() {
  return (
    <section id="security" className="bg-brand-navy py-24 sm:py-28" data-testid="trust-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow tone="gold">Government-grade</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
              Built for environments where trust matters.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={0.05 * i}>
              <div className="h-full bg-brand-navy p-7 transition-colors hover:bg-brand-navy-700" data-testid={`trust-pillar-${i}`}>
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-white/[0.06] ring-1 ring-white/10">
                  <p.icon className="h-5 w-5 text-brand-gold" strokeWidth={1.9} />
                </span>
                <h3 className="mt-5 font-display text-base font-bold text-white">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
